import React from 'react';
import classNames from 'classnames';

type Sensor = {
    battery: string;
};

type Props = {
    sensor: Sensor;
};

export const Battery: React.FC<Props> = ({ sensor }) => {
    return (
        <span
            className={classNames(
                'dashboard-battery',
                `dashboard-battery--${sensor.battery.toLowerCase()}`,
            )}
            title={sensor.battery}
        >
      {sensor.battery}
    </span>
    );
};